import { inject, injectable } from 'inversify'
import { SERVICE_TYPES } from '@/core/container/types'
import type { Resolvable } from '@/services/resolvers/types'
import type MarketingDataService from '@/services/domain/marketingData/marketingDataService'
import type UserSettingsService from '@/services/domain/user/userSettingsService'
import type { MonitoringServiceInterface } from '@/services/monitoring/types'

@injectable()
export default class MarketingDataResolverService implements Resolvable {
  constructor(
    @inject(SERVICE_TYPES.MarketingDataService) protected readonly marketingDataService: MarketingDataService,
    @inject(SERVICE_TYPES.UserSettingsService) protected readonly userSettingsService: UserSettingsService,
    @inject(SERVICE_TYPES.MonitoringService)
    protected readonly monitoringService: MonitoringServiceInterface,
  ) {}

  public async resolve(): Promise<void> {
    const userSettings = this.userSettingsService.currentUserSettingsOrNull()
    if (userSettings?.showMarketingDataModal) {
      try {
        await this.marketingDataService.fetchMarketingData()
      } catch (e) {
        this.monitoringService.logError(e as Error)
      }
    }
  }

  public async unresolve(): Promise<void> {
    this.marketingDataService.deleteAllFromStore()
  }
}
